import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import APIDataFetchLoader from "../Utils/APIDataFetchLoader";

const SiteUrl = process.env.REACT_APP_SITEURL;
const WebsiteAPIurl = SiteUrl + "admin/API/";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [RendomTokenfetch, setRendomTokenfetch] = useState(null);
  const [webSetting, setwebSetting] = useState([]);
  const [Pagemetatags, setPagemetatags] = useState([]);
  const [tokenLoading, setTokenLoading] = useState(false);
  const [settingLoading, setSettingLoading] = useState(false);
  const [metatagsLoading, setMetatagsLoading] = useState(false);

  useEffect(() => {
    const FetchRendomToken = async () => {
      setTokenLoading(true);
      try {
        let fdata = new FormData();
        fdata.append("Status", "1");

        const response = await axios.post(
          `${WebsiteAPIurl}rendomTokenfetch.php`,
          fdata
        );
        // console.log("RendomTokenfetch", response.data);
        if (response.data && response.data.status === "1") {
          setRendomTokenfetch(response.data.token);
        } else {
          setRendomTokenfetch(null);
        }
      } catch (err) {
        console.error("Token Fetch Error:", err.message);
      } finally {
        setTokenLoading(false);
      }
    };

    FetchRendomToken();
  }, []);

  // Website Setting Data Fetch
  useEffect(() => {
    const fetchWebsiteSetting = async () => {
      if (!RendomTokenfetch) return;
      try {
        setSettingLoading(true);
        const res = await axios.get(`${WebsiteAPIurl}website_settingAPI.php`, {
          headers: {
            Authorization: RendomTokenfetch,
          },
        });
        // console.log("Website", res.data.sitedata);
        if (res.data && res.data.status === "1") {
          setwebSetting(res.data.sitedata);
        } else {
          // console.warn("fetch failed:", res.data?.message || "Unknown");
        }
      } catch (err) {
        console.error("Fetch Error:", err.message);
      } finally {
        setSettingLoading(false);
      }
    };

    fetchWebsiteSetting();
  }, [RendomTokenfetch]);

  useEffect(() => {
    const fetchPageMetatags = async () => {
      if (!RendomTokenfetch) return;
      try {
        setMetatagsLoading(true);
        const res = await axios.get(`${WebsiteAPIurl}pagemetaTags.php`, {
          headers: {
            Authorization: RendomTokenfetch,
          },
        });
        // console.log("Website", res.data.sitedata);
        if (res.data && res.data.status === "1") {
          setPagemetatags(res.data.sitedata);
        } else {
          // console.warn("fetch failed:", res.data?.message || "Unknown");
        }
      } catch (err) {
        console.error("Fetch Error:", err.message);
      } finally {
        setMetatagsLoading(false);
      }
    };

    fetchPageMetatags();
  }, [RendomTokenfetch]);

  const isLoading = tokenLoading || settingLoading || metatagsLoading;

  return (
    <AuthContext.Provider
      value={{
        RendomTokenfetch,
        webSetting,
        Pagemetatags,
        tokenLoading,
        settingLoading,
        metatagsLoading,
      }}
    >
      {/* {isLoading ? <APIDataFetchLoader /> : children} */}

      <>
        {children}
        {isLoading && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(255,255,255,0.8)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 9999,
            }}
          >
            <APIDataFetchLoader />
          </div>
        )}
      </>
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
